module.exports = __webpack_public_path__ + "f1625edb0f46cb06f90a0edffd1bce8c.png";